import React, { useState, useEffect, Fragment } from "react";
import Breadcrumb from "../../components/common/breadcrumb";
import axiosConfig from "../../services/axiosConfig";
import setHeader from "../../components/Functions/setHeader";
import SweetAlert from "sweetalert2";
import { Link } from "react-router-dom";
import { SITE_URL } from "../../services/Const";
import NoDataHandler from "../../components/common/NoDataHandler";
import { DashedStyle } from "../../constant";
import LoadingComponent from "../../components/common/LoadingComponent";

const AllHomeSection = () => {
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]);

    useEffect(() => {
        getData();

    }, []);

    const getData = () => {
        setLoading(true);
        setData([]); // Reset data before fetching new data

        axiosConfig.get("home-section-list", setHeader())
            .then((res) => {
                setData(res.data.data);
            })
            .catch((error) => {
                console.error("Error fetching data:", error);
            })
            .finally(() => {
                setLoading(false); // ✅ This will run after the promise resolves/rejects
            });
    };

    const DeleteData = (id) => {
        SweetAlert.fire({
            title: "Are you sure?",
            text: "Once deleted, you will not be able to recover this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Ok",
            cancelButtonText: "Cancel",
            reverseButtons: true,
        }).then((result) => {
            if (result.isConfirmed) {
                axiosConfig
                    .get(`delete-home-section/${id}`, setHeader())
                    .then((res) => {
                        if (!res.data.error) {
                            SweetAlert.fire({
                                title: "Success",
                                text: res.data.messages,
                                icon: "success",
                            });
                            getData(); // Refresh the list
                        } else {
                            SweetAlert.fire({
                                title: "Oops!",
                                text: res.data.messages,
                                icon: "error",
                            });
                        }
                    })
                    .catch((error) => {
                        console.error("Error deleting data:", error);
                        SweetAlert.fire({
                            title: "Error",
                            text: "An error occurred while deleting the data.",
                            icon: "error",
                        });
                    });
            }
        });
    };

    // Show loading state first
    if (loading) {
        return (
            <LoadingComponent breadCrubTitle='Home Section List' breadCrubParent='Home Section' />
        );
    }

    // Show no data only after loading is complete and data is empty
    if (!loading && data.length === 0) {
        return (
            <Fragment>
                <Breadcrumb title="Home Section List" parent="Home Section" />
                <NoDataHandler title='No Home Section Data' />
            </Fragment>
        );
    }
    return (
        <Fragment>
            <Breadcrumb title="Home Section List" parent="Home Section" />
            <div className="container-fluid">
                <div className="row">
                    <div className="col-sm-12">
                        <div className="table-responsive">
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th scope="col">#</th>
                                        <th scope="col">Text</th>
                                        <th scope="col">Type</th>
                                        <th scope="col">Image</th>
                                        <th scope="col">Expiry</th>
                                        <th scope="col">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.map((item, index) => {
                                        return (
                                            <tr key={index}>
                                                <th scope="row">{index + 1}</th>
                                                <td>{item.text}</td>
                                                <td>{item.type}</td>
                                                <td>
                                                    <img
                                                        src={item.image}
                                                        alt="HomeSectionImage"
                                                        width="100"
                                                        height="50"
                                                    />
                                                </td>
                                                <td>
                                                    {(() => {
                                                        if (item.expire_date === '0000-00-00 00:00:00' || item.expire_date === '000-00-00 00:00:00') {
                                                            return 'No Expiry Date';
                                                        }

                                                        const expireDate = new Date(item.expire_date);
                                                        const currentDate = new Date();

                                                        return expireDate < currentDate ? 'Expired' : 'Valid';
                                                    })()}
                                                </td>

                                                <td>
                                                    <Link
                                                        to={`/pages/home-section/edit/${item.h_id}`}
                                                        className="btn btn-xs btn-outline-success"
                                                    >
                                                        Edit
                                                    </Link>
                                                    &nbsp;
                                                    <button
                                                        title="Delete"
                                                        className="btn btn-xs btn-outline-danger"
                                                        onClick={(e) => DeleteData(item.h_id)}
                                                    >
                                                        Delete
                                                    </button>
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

export default AllHomeSection;
